import React, { useState, useContext, useEffect, Fragment } from "react";
import "../Styles.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/search/Search.css";
import "../../../ui-styles/inlineLink/inlineLinkIcon.css";
import "../../../ui-styles/list/profileWrapList.css";
import { LangCtx, RoleCtx, PayLoadCtx } from "../../../lib/context";
import "../../common/bookAppointment/BookAppointments.css";
import "../../../ui-styles/list/contactListAction.css";
import { useParams } from 'react-router-dom';

// import AdminList from "./components/admin/AdminList";
import ClinicList from "./components/clinic/ClinicList";
import DoctorList from "./components/doctor/DoctorList";
import PatientList from "./components/patient/PatientList";

const AdminUsers = (props) => {
    const { l } = useContext(LangCtx);
    const { role } = useContext(RoleCtx);
    const { payload } = useContext(PayLoadCtx);
    const [active, setActive] = useState(role === "CA" ? "C" : "P");
    const { profile } = useParams();

    useEffect(() => {
        if (profile === 'doctor') {
            setActive("D")
        }
        else if (profile === 'patient') {
            setActive("P")
        } else if (role === "SA") {
            setActive("A")
        }
    }, [profile, role])

    return (
        <div className="baseContainer">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.users_list}</h2>
                </div>
                <div className="tabCol">
                    <div className="row hndlpdn08">
                        {/* {role === "SA" && <div className={active === "A" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => setActive("A")}>
                            <span>{l.admins}</span>
                        </div>} */}
                        {role === "CA" &&
                            <Fragment>
                                <div className={active === "C" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => { active !== "C" && setActive("C") }}>
                                    <span>{l.clinics}</span>
                                </div>
                                <div className={active === "D" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => { active !== "D" && setActive("D") }}>
                                    <span>{l.doctors}</span>
                                </div>
                                <div className={active === "P" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => { active !== "P" && setActive("P") }}>
                                    <span>{l.patients}</span>
                                </div>
                            </Fragment>
                        }
                        {role === "C" && <Fragment>
                            <div className={active === "P" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => { active !== "P" && setActive("P") }}>
                                <span>{l.patients}</span>
                            </div>
                            <div className={active === "D" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"} onClick={(e) => { active !== "D" && setActive("D") }}>
                                <span>{l.doctors}</span>
                            </div>
                        </Fragment>
                        }
                    </div>
                </div>
            </div>
            {/* {active === "A" &&
                <AdminList active={active} setActive={setActive} l={l} />
            } */}
            {
                active === "C" &&
                <ClinicList active={active} setActive={setActive} role={role} l={l} userId={payload?.userId ? payload.userId : null} />
            }
            {
                active === "D" &&
                <DoctorList active={active} setActive={setActive} role={role} l={l} userId={payload?.userId ? payload.userId : null} />
            }
            {
                active === "P" &&
                <PatientList active={active} setActive={setActive} role={role} l={l} userId={payload?.userId ? payload.userId : null} />
            }
        </div>
    )
}

export default AdminUsers;
